import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

class AppApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetDataSourceStatus() {
        const { data } = await this.httpClient.get(`/app/data-source-status`);
        return data;
    }
}

export default AppApi;
